import React from "react";
import BookingButton from "../../components/public/BookingButton";
import { FaChevronRight } from "react-icons/fa";
import styles from "../../styles/public/booking-navigation.module.css";

const BookingNavigation = ({ onClick, handleContinue, disabled, continueText, showContinueButton }) => {
  return (
    <div className={`${styles["navigation-buttons"]} d-flex justify-content-between px-3 py-2 bg-dark mx-auto`}>
      <BookingButton variant="secondary" onClick={onClick}>
        Back
      </BookingButton>
      {showContinueButton && (
        <BookingButton
          variant="primary"
          onClick={handleContinue}
          disabled={disabled}
        >
          {continueText || "Continue"} <FaChevronRight />
        </BookingButton>
      )}
    </div>
  );
};

export default BookingNavigation;